import React, { useEffect, useRef } from 'react';
import {
  FINAL_SUBMISSION_SUCCESS_COPY,
  handleFinalSubmissionSuccessRefresh
} from '../offline/finalSubmissionSuccessUi';

/**
 * Confirms that a final count reached the manager before the user refreshes.
 * Deliberately has no dismiss action: OK is the controlled refresh path.
 */
export default function FinalSubmissionSuccessModal({
  open,
  onConfirm = handleFinalSubmissionSuccessRefresh,
  copy = FINAL_SUBMISSION_SUCCESS_COPY
}) {
  const confirmRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const t = window.setTimeout(() => {
      try {
        confirmRef.current?.focus();
      } catch (_) {
        /* ignore */
      }
    }, 0);
    return () => window.clearTimeout(t);
  }, [open]);

  if (!open) return null;

  return (
    <div className="cs-modal-overlay" role="presentation">
      <div
        className="cs-modal cs-final-submission-success-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cs-final-submission-success-title"
      >
        <h2
          id="cs-final-submission-success-title"
          className="cs-modal-title cs-modal-title-neutral"
        >
          {copy.title}
        </h2>
        {(copy.paragraphs || []).map((text) => (
          <p key={text} className="cs-modal-text">
            {text}
          </p>
        ))}
        <div className="cs-modal-actions cs-final-submission-success-actions">
          <button
            ref={confirmRef}
            type="button"
            className="btn btn-primary"
            onClick={onConfirm}
          >
            {copy.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
